import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { components } from "../components";
import { useTranslation } from "react-i18next";
import SettingItem from "../components/profile/SettingItem";
import { APP_ROUTES } from "../constants/app_routes";

export const SettingsScreen: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderHeader = (): JSX.Element => {
    return <components.Header title={t("setting")} goBack={true} />;
  };

  return (
    <>
      {renderHeader()}
      <main style={{ paddingBottom: 0 }} className="setting">
        <SettingItem
          to={APP_ROUTES.WITHDRAW_PASSWORD}
          title={t("withdrawPassword")}
        />
        <SettingItem
          to={APP_ROUTES.UPDATE_ACCOUNT}
          title={t("connectBankAccount")}
        />
        <SettingItem
          to={APP_ROUTES.UPDATE_PASSWORD}
          title={t("loginPassword")}
        />
        <p className="profile__menu-title">{t("tradeNotice")}</p>
        <SettingItem onClick={() => {}} title="binary" />
        <p className="profile__menu-title">{t("sellTradeConfirm")}</p>
        <SettingItem onClick={() => {}} title="binary" />
        <p className="profile__menu-title">{t("notification")}</p>
        <SettingItem onClick={() => {}} title={t("closeTrade")} />
        <SettingItem onClick={() => {}} title={t("supportTeamAlert")} />
      </main>
    </>
  );
};
